"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snakeToCamelCase = function (str) { return str.replace(/([-_][a-z])/g, function (group) { return group.toUpperCase()
    .replace('-', '')
    .replace('_', ''); }); };
exports.getMajorVersion = function (version) {
    if (version !== undefined && version !== null && version.indexOf('.') !== -1) {
        var versionNumber = Number.parseInt(version.split('.')[0]);
        if (!Number.isNaN(versionNumber)) {
            return versionNumber;
        }
    }
    return (-1);
};
//# sourceMappingURL=utils.js.map